<template>
    <v-col cols="12" sm="12" style="background-color: white">
        <v-container class="app-container">
            <home-title :title="$t('howPlatformWorks')"></home-title>

            <v-row class="pb-sm-12 justify-space-around content-list">
                <v-col
                    cols="12" xs="12" sm="6" md="4" class="d-flex flex-column align-center pb-12 content-list__item"
                    v-for="item in content"
                    :key="item.id"
                >
                    <div class="pb-6">
                        <v-img
                            :src="item.image"
                            contain
                            width="80"
                            height="80"
                        ></v-img>
                    </div>
                    <p class="text-center mb-0">{{ item.text }}</p>
                </v-col>
            </v-row>

            <div class="text-center">
                <home-button
                    to="/info/o-nas"
                    :text="$t('aboutUs')"
                ></home-button>
            </div>
        </v-container>
    </v-col>
</template>

<script>
    import HomeButton from './HomeButton';
    import HomeTitle from './HomeTitle';

    export default {
        name: 'HomeContent',
        components: {
            HomeButton,
            HomeTitle,
        },
        props: {
            content: {
                required: true,
                type: Array,
            }
        }
    }
</script>

<style scoped>

</style>
